var _g;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgLocation(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, ["title", "titleId"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlSpace: "preserve",
    width: "2.4324cm",
    height: "3.24518cm",
    shapeRendering: "geometricPrecision",
    textRendering: "geometricPrecision",
    imageRendering: "optimizeQuality",
    fillRule: "evenodd",
    clipRule: "evenodd",
    viewBox: "0 0 515.11 687.23",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    xmlnsxodm: "http://www.corel.com/coreldraw/odm/2003",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Layer_x0020_1"
  }, /*#__PURE__*/React.createElement("metadata", {
    id: "CorelCorpID_0Corel-Layer"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "black",
    d: "M137.27 264.72c-1.83,-16.1 3.52,-38.84 8.42,-51.18 38.02,-95.7 171.25,-102.54 218.76,-10.45 7.66,14.86 11.46,28.62 12.95,47.63 2.81,35.85 -13.52,69.75 -31.47,88.48 -18.92,19.74 -44.65,36.57 -81.76,38.65 -51.15,2.87 -93.83,-26.01 -114.01,-65.73 -7.91,-15.57 -10.73,-28.43 -12.88,-47.4zm106.77 -264c-14.31,1.73 -16.54,0.65 -33.72,4 -83.77,16.34 -154.11,70.85 -188.46,149.38 -8.33,19.05 -13.11,35.87 -17.75,57.17 -4.47,20.52 -4.96,48.14 -3.04,69.64 6.71,75.13 46.02,154.65 86.28,214.43 23.03,34.18 54.13,76.01 81.33,106.32l35.78 39.27c13.04,13.72 24.25,24.42 37.56,37.51 17.1,16.81 23.65,6.15 35.09,-4.13 3.33,-3 6.68,-6.08 9.76,-9.29 6.38,-6.66 12.28,-12.15 18.66,-18.87 37.86,-39.88 69.15,-75.98 102.58,-122.63 31.99,-44.64 60.28,-91.79 81.1,-144.07 10.17,-25.53 16.22,-46.13 21.11,-73.15 0.91,-5.04 1.51,-11.07 2.52,-16.49 5.27,-28.31 0.72,-74.44 -7.29,-100.69 -3.09,-10.12 -5.84,-18.78 -9.52,-27.92 -1.81,-4.5 -3.71,-8.65 -5.66,-12.89 -1.06,-2.3 -1.96,-4.13 -3.07,-6.4 -24.49,-49.9 -66.77,-90.47 -118.6,-116.23 -15.28,-7.59 -37.65,-15.85 -55.55,-19.34 -19.08,-3.72 -48.73,-8.07 -69.11,-5.61z"
  }))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgLocation);
export default __webpack_public_path__ + "static/media/location.8b97270e.svg";
export { ForwardRef as ReactComponent };